var _g, _g2, _g3, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 780,
    height: 733,
    viewBox: "0 0 780 733",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_6_5206)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M793.618 326.696C747.686 335.729 711.77 359.64 697.507 388.809C683.654 417.143 697.118 447.038 722.631 471.889C747.892 496.496 785.313 516.874 831.408 519.239C876.514 521.554 915.779 503.944 947.477 483.428C979.21 462.89 1007.25 437.538 1001.78 408.971C996.295 380.377 959.42 360.092 920.918 344.874C882.067 329.517 837.329 318.1 793.618 326.696Z",
    fill: "#FAFF00"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter1_f_6_5206)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M346.903 323.83C283.488 325.706 218.608 345.59 192.228 376.589C168.097 404.951 204.455 435.886 227.13 464.592C242.591 484.168 265.446 501.145 299.32 512.179C329.899 522.139 365.503 519.682 401.152 521.275C456.639 523.755 518.036 542.406 561.758 523.908C608.604 504.088 618.372 465.938 605.949 434.63C594.103 404.778 544.173 386.519 499.693 367.494C452.786 347.432 406.799 322.059 346.903 323.83Z",
    fill: "#FF85F7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter2_f_6_5206)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M594.102 181.593C538.365 192.481 507.394 232.22 476.104 267.803C446.815 301.11 418.193 336.069 423.57 375.522C429.284 417.433 460.078 455.263 505.2 481.264C552.58 508.566 611.703 523.726 671.484 518.378C733.967 512.789 796.87 491.913 829.263 452.276C860.11 414.531 840.5 368.488 829.33 325.237C818.507 283.329 811.609 238.257 766.949 210.985C719.677 182.117 653.517 169.986 594.102 181.593Z",
    fill: "#47D16C"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter3_f_6_5206)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M474.547 360.427C454.414 361.625 433.815 374.314 425.44 394.098C417.778 412.197 429.323 431.94 436.521 450.261C441.43 462.753 448.686 473.588 459.44 480.629C469.149 486.986 480.453 485.418 491.772 486.435C509.389 488.017 528.881 499.92 542.763 488.115C557.637 475.466 560.737 451.119 556.794 431.138C553.033 412.087 537.18 400.434 523.058 388.292C508.165 375.489 493.565 359.296 474.547 360.427Z",
    fill: "#0073FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6_5206",
    x: 491.959,
    y: 123.742,
    width: 710.506,
    height: 595.702,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_6_5206"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_6_5206",
    x: -15.7259,
    y: 123.742,
    width: 826.603,
    height: 608.26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_6_5206"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_6_5206",
    x: 222.915,
    y: -22.7717,
    width: 822.915,
    height: 742.215,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_6_5206"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_6_5206",
    x: 262.915,
    y: 200.371,
    width: 455.443,
    height: 452.909,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 80,
    result: "effect1_foregroundBlur_6_5206"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBack);
export default __webpack_public_path__ + "static/media/newBack.dee8bab4dea28eeab0fa39e8867e54d6.svg";
export { ForwardRef as ReactComponent };